/**
 * Чистый маппер key→action. Развязан с DOM, поэтому тривиально
 * покрывается unit-тестами. Вызывающий код заводит action обратно в state виджета.
 *
 * @param {string} key — значение KeyboardEvent.key
 * @param {{activeIndex: number, items: ReadonlyArray<unknown>}} ctx
 * @returns {{type: 'move', activeIndex: number}
 *          | {type: 'select', index: number}
 *          | {type: 'close'}
 *          | {type: 'noop'}}
 */
export function handleKey(key, { activeIndex, items }) {
    const total = items.length;
    if (key === 'ArrowDown') {
        const next = total === 0 ? -1 : Math.min(activeIndex + 1, total - 1);
        return { type: 'move', activeIndex: next };
    }
    if (key === 'ArrowUp') {
        const next = Math.max(activeIndex - 1, 0);
        return { type: 'move', activeIndex: next };
    }
    if (key === 'Escape') {
        return { type: 'close' };
    }
    if (key === 'Enter') {
        if (activeIndex < 0 || activeIndex >= total) return { type: 'noop' };
        return { type: 'select', index: activeIndex };
    }
    return { type: 'noop' };
}
